import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import makeStyles from "@material-ui/styles/makeStyles";

const ReactSVGIcon = lazy(() =>
	import(/* webpackChunkName: "reactSVGIcon" */ "@micado-digital/react-svg-icon/ReactSVGIcon")
);
const ReactLink = lazy(() =>
	import(/* webpackChunkName: "reactLink" */ "@micado-digital/react-link/ReactLink")
);

const useStyles = makeStyles(theme => ({
	link: {
		color: "inherit",
		display: "block",
		margin: theme.spacing(0, 0.5),
		padding: theme.spacing(0.5, 0.5),
		transition: theme.transitions.create("color", {
			duration: theme.transitions.duration.complex
		}),
		"&:hover, &:focus": {
			color: "#FFFFFF"
		},
		[theme.breakpoints.down("md")]: {
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap"
		},
		...theme?.customTypography?.footer02?.metamenu?.mobile?.level1,
		[theme.breakpoints.up("lg")]: {
			...theme?.customTypography?.footer02?.metamenu?.desktop?.level1
		}
	},
	linkSelected: {
		textDecoration: "underline"
	},
	icon: {
		marginRight: theme?.spacing(2)
	}
}));

const MetamenuItem = ({ icon, link, selected, target, title }) => {
	const css = useStyles();
	const hasHref = link && link !== "#";

	return (
		<Suspense fallback={<></>}>
			<ReactLink
				className={clsx("mco-footer-02__footermenu-item", css.link, {
					[css.linkSelected + " mco-footer-02__footermenu-item--selected"]: selected
				})}
				to={hasHref ? link : "#"}
				target={target ? target : null}
			>
				{icon && (
					<Suspense fallback={<></>}>
						<ReactSVGIcon
							className={clsx("mco-footer-02__footermenu-icon", css.icon)}
							src={icon}
						></ReactSVGIcon>
					</Suspense>
				)}
				<span dangerouslySetInnerHTML={{ __html: title }} />
			</ReactLink>
		</Suspense>
	);
};

MetamenuItem.propTypes = {
	icon: PropTypes.string,
	link: PropTypes.string.isRequired,
	selected: PropTypes.bool,
	target: PropTypes.string,
	title: PropTypes.string.isRequired
};

export default MetamenuItem;
